export interface MonthlySpendDataResponse {
  month: string
  amountCents?: number
  virtualAmountCents?: number
  physicalAmountCents?: number
  billPayAmountCents?: number
}

export class MonthlySpendDataModel {
  public month: string
  public legacyAmountCents?: number
  public virtualAmountCents?: number
  public physicalAmountCents?: number
  public billPayAmountCents?: number

  public constructor(data: MonthlySpendDataResponse) {
    this.month = data.month
    this.legacyAmountCents = data.amountCents
    this.virtualAmountCents = data.virtualAmountCents
    this.physicalAmountCents = data.physicalAmountCents
    this.billPayAmountCents = data.billPayAmountCents
  }

  public get amountCents(): number {
    return this.virtualAmountCents ?? this.legacyAmountCents ?? 0
  }
}
